module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0069.jpg?v=0bc57e82";